// src/services/produtos/BarraService.js
import { fetchData } from '../Api';

export const buscarBarrasPorProduto = (produtoId) =>
    fetchData(`/Barra/GetBarraByProdutoId?produtoId=${produtoId}`);
